<template>
    <v-row>         
        <v-col>
            <v-card
                class="pb-4 mx-auto"
                width="500"
                
            >
                    <v-card-title
                        class="text-subtitle-2 pa-2 white--text d-flex justify-center primary"
                    >
                        <v-spacer></v-spacer>
                        <span>Print / View Reports</span>
                        <v-spacer></v-spacer>                   
                    </v-card-title>
                    <v-card-text
                        style="height: 60vh; overflow-y: auto;"
                    >
                        <v-list two-line>
                            <v-list-item-group
                                active-class="primary--text"
                                v-model="selectedReport"
                            >
                                <div v-for="(item, index) in items" :key="index">                                   
                                    <v-list-item 
                                        @click="displayReport(item.report)"
                                    >
                                       <template v-slot:default="{ active }">
                                           <v-list-item-content>
                                               <v-list-item-title>
                                                {{ item.title }}
                                               </v-list-item-title>
                                               <v-list-item-subtitle
                                                    class="text--primary"
                                               >
                                                {{ item.subtitle }}
                                               </v-list-item-subtitle>
                                           </v-list-item-content>
                                           <v-list-item-action>
                                               <v-icon
                                                    v-if="!active"
                                                    color="grey lighten-1"
                                               >
                                                   mdi-printer-search
                                               </v-icon>
                                               <v-icon
                                                    v-else
                                                    color="primary"
                                               >
                                                   mdi-printer-search
                                               </v-icon>
                                           </v-list-item-action>
                                       </template>
                                   </v-list-item>

                                   <v-divider
                                        v-if="index < items.length -1"
                                        :key="index"
                                   ></v-divider>
                                </div>
                            </v-list-item-group>
                        </v-list>
                    </v-card-text>

                    <v-overlay
                        absolute
                        :value="overlay"
                        color="grey"
                        opacity="0.6"
                   >
                        <v-progress-circular 
                            transition="fade-transition" 
                            indeterminate 
                            size="64"
                            v-show="loading"
                            color="primary"
                        ></v-progress-circular>
                        
                        <v-expand-transition>                            
                            <v-card
                                max-width="300"
                                class="mx-auto"
                                transition="scroll-y-transition"
                                v-show="expand"
                                light
                            >
                                 
                                <v-card-title
                                    class="d-flex justify-center primary white--text"
                                >
                                    <span>{{ reportOption }}</span>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text                
                                        x-small
                                        color="white"
                                        @click="close"
                                    >
                                        <v-icon>mdi-window-close</v-icon>
                                    </v-btn> 
                                </v-card-title>
                                <v-list 
                                    light
                                    v-if="displayAcademicPeriod"
                                >
                                    <v-list-item>                                        
                                        <v-autocomplete
                                            v-model="academicPeriod"
                                            :items="academicPeriods"
                                            item-text="text"
                                            item-value="value"                                                
                                            dense
                                            filled
                                            color="blue-grey lighten-2"
                                            prepend-icon="mdi-calendar"
                                            hide-details=""
                                        ></v-autocomplete>                                        
                                    </v-list-item>
                                </v-list>

                                <div style="max-height: 400px;  overflow-y: auto">    
                                    <v-list 
                                        v-if="listGroup"
                                        light
                                    >
                                        <v-list-group
                                            v-for="item in formClassesFilter"
                                            :key = "item.title"
                                            v-model="item.active"
                                            :prepend-icon="item.action"
                                            no-action
                                        >
                                            <template v-slot:activator>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        {{ item.title }}
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </template>
                                            <v-list-item
                                                v-for="subItem in item.items"
                                                :key="subItem.title"
                                                @click="setSelectedClass(subItem.title)"                                       
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title >
                                                        {{ subItem.title }}
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-group>
                                    </v-list>
                                    <v-list
                                        v-else
                                    >
                                        <v-list-item-group
                                            v-model="selectedFormLevel"
                                            color="primary"
                                        >
                                            <v-list-item
                                                v-for="(item, i) in formLevels"
                                                :key="i"
                                                @click="setSelectedFormLevel(item.value)" 
                                            >
                                                <v-list-item-icon>
                                                    <v-icon>
                                                        {{ item.icon }}
                                                    </v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        {{ item.text }}
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </div>

                                <v-card-actions
                                    v-if="cardActions"
                                >
                                    <v-btn
                                        block
                                        text
                                        outlined
                                        @click="showReport"
                                    >
                                        Display Report
                                    </v-btn>
                                </v-card-actions>
                            </v-card> 
                        </v-expand-transition>

                         <v-expand-transition>                            
                            <v-card
                                max-width="600"
                                class="mx-auto"
                                transition="scroll-y-transition"
                                v-show="expandSelectStudent"
                                light
                            >
                                 
                                <v-card-title
                                    class="d-flex justify-center primary white--text"
                                >
                                   <span>Select Student</span>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text                
                                        x-small
                                        color="white"
                                        @click="close"
                                    >
                                        <v-icon>mdi-window-close</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-card-text>
                                    <v-data-table
                                        :headers="headersStudents"
                                        :items="students"
                                        :search="searchStudent"
                                        :loading="loadingStudents"
                                        fixed-header
                                        height="40vh"
                                    >
                                        <template v-slot:top>
                                            <v-text-field
                                                v-model="searchStudent"
                                                label="Search Student"
                                                append-icon="mdi-magnify"
                                                single-line
                                                clearable
                                            ></v-text-field>
                                        </template>

                                        <template v-slot:[`item.actions`]="{ item }">
                                            <v-btn
                                                depressed 
                                                color="primary"
                                                @click="setSelectedStudent(item)"
                                                small
                                            >Select</v-btn>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                         </v-expand-transition>    

                   </v-overlay>    
                </v-card>
        </v-col>

        <v-dialog
            v-model="reportViewer"
            max-width="90vw"
            persistent
        >
            <v-card
               height="90vh"
               style="position:relative;" 
            >                
                <iframe 
                    ref="pdf" 
                    style="width:100%; height:92%" 
                    class="report-viewer"  
                    :src="src"
                ></iframe>              
                <v-overlay
                    absolute
                    :value="reportViewerOverlay"
                    color="white"
                    opacity="0.60"
                >
                    <v-progress-circular
                        indeterminate
                        size="64"
                        color="primary"
                    ></v-progress-circular>
                </v-overlay>
                
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="downloadOption"
                        color="primary"
                        outlined
                        @click="downloadSpreadsheet"
                        class="mr-3"
                    >
                        Download Spreadsheet
                    </v-btn>
                    <v-btn
                        color="primary"
                        class="mr-3"
                        @click="closeReport"
                    >Close Report</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> 
    </v-row>    
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
export default {
    created(){
        this.initialize()
    },
    
    data: () => ({
        selectedReport: null,
        items: [
            { 
                title: 'Report Cards by Class', 
                subtitle: '', 
                icon: 'mdi-printer-search',
                report: 'report-card-class', 
            },            
            { 
                title: 'Class Mark Sheets', 
                subtitle: '', 
                icon: 'mdi-printer-search',
                report: 'marksheet-class', 
            },            
            { 
                title: 'Class Lists', 
                subtitle: '', 
                icon: 'mdi-printer-search',
                report: 'class-list', 
            }, 
            { 
                title: 'Student Totals by Class', 
                subtitle: '', 
                icon: 'mdi-printer-search',
                report: 'class-population', 
            },
            { 
                title: 'Email List', 
                subtitle: '', 
                icon: 'mdi-printer-search',
                report: 'email-list', 
            },
            { 
                title: 'Device / Internet Report', 
                subtitle: '', 
                icon: 'mdi-printer-search',
                report: 'device-internet', 
            },           
            // { 
            //     title: 'Subject Choices Marksheets By Class', 
            //     subtitle: '', 
            //     icon: 'mdi-printer-search',
            //     report: 'marksheet-subject-choice-class', 
            // },            
            // { 
            //     title: 'Subject Choices Marksheets By Student', 
            //     subtitle: '', 
            //     icon: 'mdi-printer-search',
            //     report: 'marksheet-subject-choice-student', 
            // },            
            // { 
            //     title: 'NCSE Marksheets', 
            //     subtitle: '', 
            //     icon: 'mdi-printer-search',
            //     report: 'marksheet-ncse' 
            // },            
            // { 
            //     title: 'Registration Status Report', 
            //     subtitle: '', 
            //     icon: 'mdi-printer-search',
            //     report: 'registration-status' 
            // },
            { 
                title: 'School Feeding Report', 
                subtitle: '', 
                icon: 'mdi-printer-search',
                report: 'school-feeding' 
            },              
            { 
                title: 'Student Contact Information', 
                subtitle: '', 
                icon: 'mdi-printer-search',
                report: 'contact-information' 
            },
             { 
                title: 'ASR - Student Ethnic Group Statistics', 
                subtitle: '', 
                icon: 'mdi-printer-search',
                report: 'ethnic-group-statistics' 
            },
            { 
                title: 'ASR - Student Religion Statistics', 
                subtitle: '', 
                icon: 'mdi-printer-search',
                report: 'religion-statistics' 
            },
            { 
                title: 'ASR - Student Age Statistics', 
                subtitle: '', 
                icon: 'mdi-printer-search',
                report: 'age-statistics' 
            },            
            { 
                title: 'Student Health Data', 
                subtitle: '', 
                icon: 'mdi-printer-search',
                report: 'health-data' 
            },            
            { 
                title: 'Foreign Students', 
                subtitle: '', 
                icon: 'mdi-printer-search',
                report: 'foreign-students' 
            },            
            // { 
            //     title: 'ASR', 
            //     subtitle: '', 
            //     icon: 'mdi-printer-search',
            //     report: 'asr' 
            // },            
        ],
        overlay: false,
        loading: false,
        expand: false,
        expandSelectStudent: false,
        formClasses: [],
        formClassesFilter: [],
        academicPeriod: '',        
        academicPeriods: [],        
        reportViewer: false,
        reportViewerOverlay: false,
        src: null,
        reportSelected: null,
        formLevelFilter: null,
        displayAcademicPeriod: false,
        students: [],
        selectedStudent: null,
        headersStudents: [],
        searchStudent: '',
        loadingStudents: false,
        activeFormLevel: '',
        listGroup: false,
        formLevels: [],
        selectedFormLevel: null,
        reportOption: 'Select Class',
        cardActions: false,
        downloadOption: false,
    }),


    methods:{
        ...mapMutations({
            setEndpoint: 'printViewReports/setEndpoint'
        }),

        ...mapActions({
            getFormClassesList: 'termReports/getFormClassesList',
            getMarkSheetTerms: 'printViewReports/getMarkSheetTerms',
            getReportCardTerms: 'printViewReports/getReportCardTerms',
            getStudents: 'common/getCurrentStudents',
            getClassListYears: 'printViewReports/getClassListYears',
            downloadASR: 'printViewReports/downloadASR',
            getSpreadsheet: 'printViewReports/downloadSpreadsheet',
        }),

        initialize () {
            this.overlay = true;
            this.loading = true;
            this.mapFormClasses();
            this.loading = false;
            this.overlay = false;
        },

        async mapFormClasses () {
            try {
                const { data } = await this.getFormClassesList();
                if(data.length > 0){                    
                    let form1Classes = [];
                    let form2Classes = [];
                    let form3Classes = [];
                    let form4Classes = [];
                    let form5Classes = [];
                    let form6Classes = []; 
                    data.forEach(record => {
                        switch(record.form_level){
                            case "1":
                            form1Classes.push({
                                title: record.id
                            });
                            break;
                            case "2":
                            form2Classes.push({
                                title: record.id
                            });
                            break;
                            case "3":
                            form3Classes.push({
                                title: record.id
                            });
                            break;
                            case "4":
                            form4Classes.push({
                                title: record.id
                            });
                            break;
                            case "5":
                            form5Classes.push({
                                title: record.id
                            });
                            break;
                            case "6":
                            form6Classes.push({
                                title: record.id
                            });
                            break;
                        }                
                    });
                    this.formClasses.push({
                        title: 'Form 1',
                        action: 'mdi-school',                
                        items: form1Classes,
                        formLevel: 1
                    });
                    this.formClasses.push({
                        title: 'Form 2',
                        action: 'mdi-school',                
                        items: form2Classes,
                        formLevel: 2,
                    });
                    this.formClasses.push({
                        title: 'Form 3',
                        action: 'mdi-school',                
                        items: form3Classes,
                        formLevel: 3,
                    });
                    this.formClasses.push({
                        title: 'Form 4',
                        action: 'mdi-school',                
                        items: form4Classes,
                        formLevel: 4,
                    });
                    this.formClasses.push({
                        title: 'Form 5',
                        action: 'mdi-school',                
                        items: form5Classes,
                        formLevel: 5,
                    });
                    if(form6Classes.length > 0){
                        this.formClasses.push({
                            title: 'Form 6',
                            action: 'mdi-school',                
                            items: form6Classes,
                            formLevel: 6,
                        }); 
                    }
                                                              
                }                
            } catch (error) {
                console.log(error);
            }
        },

        filterFormClasses (formLevel = null) {
            this.listGroup = true;
            this.formClassesFilter = this.formClasses.map(
                value => {
                    value.active = false
                    return value;
                }
            );
            if(formLevel){
                this.formClassesFilter = this.formClasses.filter(value => {
                    if(value.formLevel == formLevel){
                        value.active = true;
                        return value;
                    }
                    
                })
            }            
        },

        setFormLevels () {
            this.listGroup = false;            
            if(this.formLevels.length == 0){                
                this.formClasses.forEach(value => {
                    this.formLevels.push({
                        icon: 'mdi-school',
                        text: 'Form ' + value.formLevel,
                        value: value.formLevel
                    })
                })
            }
        },

        async displayReport(report){
            this.reportOption = "Select Class";
            this.cardActions = false;
            this.downloadOption = false;
            switch(report){
                case 'report-card-class':
                    this.filterFormClasses();
                    this.displayAcademicPeriod = true;
                    this.overlay = true;
                    this.loading = true; 
                    this.reportSelected = report;                  
                    this.setReportCardTerms();                    
                    break
                case 'marksheet-class':
                    this.filterFormClasses();
                    this.displayAcademicPeriod = true;
                    this.overlay = true;
                    this.loading = true; 
                    this.markSheetMenu();                   
                    this.reportSelected = report;                                  
                    break
                case 'class-list':
                    this.filterFormClasses();
                    await this.setClassListYears();
                    this.displayAcademicPeriod = true;
                    this.reportSelected = report;
                    this.overlay = true;
                    this.expand= true;
                    break
                case 'class-population':
                    this.displayAcademicPeriod = false;
                    this.reportViewer = true;
                    this.reportViewerOverlay = true;
                    this.setReportSrc(report);
                    break
                case 'marksheet-subject-choice-class':
                    this.displayAcademicPeriod = false;                    
                    this.filterFormClasses(3);
                    this.reportSelected = report;
                    this.overlay = true;
                    this.expand = true;
                    break;
                case 'marksheet-subject-choice-student':
                    this.reportSelected = report;
                    this.loadingStudents = true;
                    this.formLevelFilter = 3;
                    this.setStudents();
                    this.overlay = true;
                    this.expandSelectStudent = true;
                    break;
                case 'registration-status':
                    this.reportSelected = report;
                    this.overlay = true;
                    this.reportViewer = true;
                    this.reportViewerOverlay = true;
                    this.setReportSrc(report);
                    break;
                case 'contact-information':
                    this.filterFormClasses();
                    this.displayAcademicPeriod = false;
                    this.reportSelected = report;
                    this.overlay = true;
                    this.expand= true;
                    break;
                 case 'school-feeding':
                    this.setClassListYears();
                    this.displayAcademicPeriod = true;
                    this.listGroup = false;
                    this.reportSelected = report;
                    this.reportOption = "School Feeding Report";
                    this.cardActions = true;
                    this.overlay = true;
                    this.expand = true;
                    // this.reportViewer = true;
                    // this.reportViewerOverlay = true;
                    // this.setReportSrc(report);
                    break; 
                case 'device-internet':
                    this.setFormLevels();
                    this.reportSelected = report;
                    this.overlay = true;
                    this.expand = true;                    
                    break;
                case 'asr':
                    this.reportSelected = report;
                    this.overlay = true;
                    this.download();
                    break;
                case 'ethnic-group-statistics':
                    this.reportSelected = report;
                    this.overlay = true;
                    this.reportViewer = true;
                    this.reportViewerOverlay = true;
                    this.setReportSrc(report);                  
                    break;                   
                case 'religion-statistics':
                    this.reportSelected = report;
                    this.overlay = true;
                    this.reportViewer = true;
                    this.reportViewerOverlay = true;
                    this.setReportSrc(report);                 
                    break;
                case 'age-statistics':
                    this.reportSelected = report;
                    this.overlay = true;
                    this.reportViewer = true;
                    this.reportViewerOverlay = true;
                    this.setReportSrc(report);                 
                    break;                         
                case 'health-data':
                    this.reportSelected = report;
                    this.overlay = true;
                    this.reportViewer = true;
                    this.reportViewerOverlay = true;
                    this.setReportSrc(report);                 
                    break;                         
                case 'foreign-students':
                    this.reportSelected = report;
                    this.overlay = true;
                    this.reportViewer = true;
                    this.reportViewerOverlay = true;
                    this.setReportSrc(report);                 
                    break;
                case 'email-list':
                    this.downloadOption = true;
                    this.reportSelected = report;
                    this.overlay = true;
                    this.reportViewer = true;
                    this.reportViewerOverlay = true;
                    this.setReportSrc(report);
                    break;

            }
            
        },

        async markSheetMenu(){
            try {
                let response = await this.getMarkSheetTerms();
                console.log(response);                
                let count = 0;
                response.data.forEach((record,index) => {
                    this.academicPeriods.push({
                        text: record.academic_year + " Term " + record.term,
                        value: record.academic_term_id
                    });
                    count = index;
                })
                //console.log(count);
                this.academicPeriod = response.data[count].academic_term_id;
                this.loading = false;
                // console.log(this.academicPeriods);
                this.$nextTick(function(){
                    this.expand= true;
                })
                
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
        },

        async setReportCardTerms () {            
            try {
                const { data } = await this.getReportCardTerms();                
                data.forEach(record => {
                    this.academicPeriods.push({
                        text: record.academic_year + " Term " + record.term,
                        value: record.academic_term_id
                    });                                       
                })
                this.academicPeriod = data[0].academic_term_id;
            } catch (error) {
                if(error.response) console.log(error.reponse);
                else console.log(error);
            }

            this.loading = false;
            this.$nextTick(function(){
                this.expand = true;
            })

        },

        async setClassListYears () {
            try {
                const { data } = await this.getClassListYears();
                this.academicPeriods = new Array();
                data.forEach(value => {
                    this.academicPeriods.push({
                        text: value.start + '-' + value.end,
                        value: value.academic_year_id

                    })
                    if(value.is_current == 1){
                        this.academicPeriod = value.academic_year_id;
                    }
                })
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
        },

        setSelectedClass(formClass){
            console.log(formClass);
            this.reportViewer = true;
            this.reportViewerOverlay = true;
            this.setReportSrc(this.reportSelected, formClass);         
                      
        },

        showReport () {
            // console.log(this.academicPeriod);
            this.reportViewer = true;
            this.reportViewerOverlay = true;
            this.setReportSrc(this.reportSelected);   
        },

        setSelectedFormLevel (formLevel) {
            this.selectedFormLevel = formLevel;
            this.reportViewer = true;
            this.reportViewerOverlay = true;
            this.setReportSrc(this.reportSelected); 
        },

        setReportSrc (report, formClass = null) {
            this.$nextTick( function () {
                this.$refs.pdf.onload = () => {
                    this.reportViewerOverlay = false;
                }
            })

            switch(report){
                case 'report-card-class':                    
                    this.src = process.env.VUE_APP_API_URI + 
                    `/api/report-card?academicTermId=${this.academicPeriod}&formClassId=${formClass}`;
                    console.log(this.src);
                    break;
                case 'marksheet-class':                    
                    this.src = process.env.VUE_APP_API_URI + "/api/mark-sheet/"+this.academicPeriod+"/"+formClass;
                    console.log(this.src);
                    break;
                case 'class-list':                    
                    this.src = process.env.VUE_APP_API_URI + "/api/class-list/"+formClass+"/"+this.academicPeriod;
                    break;
                case 'marksheet-subject-choice-class':
                    this.src = process.env.VUE_APP_API_URI + 
                    "/api/mark-sheet-subject-choice/"+formClass;
                    break; 
                case 'marksheet-subject-choice-student':
                    this.src = process.env.VUE_APP_API_URI + 
                    "/api/mark-sheet-subject-choice/"+formClass+"/"+this.selectedStudent;
                    break;
                case 'registration-status':
                    this.src = process.env.VUE_APP_API_URI + 
                    "/api/registration-status/1";
                    break;
                case 'contact-information':                    
                    this.src = process.env.VUE_APP_API_URI + "/api/student-contact/"+formClass;
                    break;        
                case 'school-feeding':                    
                    this.src = process.env.VUE_APP_API_URI + "/api/school-feeding/" + this.academicPeriod;
                    console.log(this.src);
                    break;        
                case 'device-internet':                    
                    this.src = process.env.VUE_APP_API_URI + "/api/device-internet/"+this.selectedFormLevel;
                    break;
                case 'ethnic-group-statistics':
                    this.src = process.env.VUE_APP_API_URI + "/api/ethnic-group-statistics";
                    break;         
                case 'religion-statistics':
                    this.src = process.env.VUE_APP_API_URI + "/api/religious-group-statistics";
                    break;         
                case 'age-statistics':
                    this.src = process.env.VUE_APP_API_URI + "/api/student-age-statistics";
                    break;          
                case 'health-data':
                    this.src = process.env.VUE_APP_API_URI + "/api/student-health";
                    break;          
                case 'foreign-students':
                    this.src = process.env.VUE_APP_API_URI + "/api/foreign-students";
                    break;   
                case 'class-population':                    
                    this.src = process.env.VUE_APP_API_URI + "/api/student-class-population";
                    console.log(this.src)
                    break; 
                case 'email-list':
                    this.src = process.env.VUE_APP_API_URI + "/api/students/email-addresses?academic_year_id=20262027";  
                    break;        
            }  
        },

        close(){
            this.expandSelectStudent = false;
            this.$nextTick(() => {
                this.expand = false;
                this.selectedReport = null;
                setTimeout(() => { this.overlay = false}, 1000);
            })
            
        },

        closeReport(){
           let reports = [
                'registration-status',
                'school-feeding',
                'ethnic-group-statistics',
                'religion-statistics',
                'age-statistics',
                'health-data',
                'subject-selection-subject'
            ]
            if(
                reports.some(value => value === this.reportSelected)
            ){
                this.overlay = false;
            }
            //this.overlay = false;
            this.reportViewer = false;
            console.log('report closing ...');
            this.src = '';
        },

        setSelectedStudent (item) {
            this.selectedStudent = item.student_id;
            this.setSelectedClass(item.form_class_id);
        },

        async setStudents () {
            this.headersStudents = [
                { text: 'ID', value: 'student_id', width: 100 },
                { text: 'Name', value: 'name' },
                { text: 'Form Class', value: 'form_class_id', width: 100 },
                { text: '', value: 'actions', width: 100, sortable: false }
            ];

            try {
                const { data } = await this.getStudents();
                this.students = data.map(value => {
                    value.name = value.first_name + ' ' + value.last_name;
                    return value;
                })
                if(this.formLevelFilter){
                    this.students = data.filter(value => {
                        if(value.form_level == this.formLevelFilter)
                        value.name = value.first_name + ' ' + value.last_name;
                        return value;
                    })
                }
                this.loadingStudents = false;                
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
        },

        async download () {
            this.loading = true;
            try {
                const { data} = await this.downloadASR();
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(
                    new Blob([data])
                );
                link.setAttribute('download', '2021-2022 Secondary Schools ASR ver. 2 UPDATED.xlsx');
                document.body.appendChild(link);
                link.click();
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
            this.loading = false;
            this.overlay = false;
        },
        
        async downloadSpreadsheet () {
            this.reportViewerOverlay = true;
            let url = "";
            switch(this.reportSelected){
                case 'class-list':
                    url = `/api/class-list-download?academic_year_id=${this.academicPeriod}&form_class_id=${this.selectedFormClass}`;
                    break;
                case 'marksheet-class':
                    url = `/api/mark-sheet/spreadsheet?academic_term_id=${this.academicPeriod}&form_class_id=${this.selectedFormClass}`;
                    break;
                case 'email-list':
                    url = `/api/students/email-addresses/spreadsheet?academic_year_id=20262027`;
                    break;
            }
            
            try {
                this.setEndpoint(url);
                const { data } = await this.getSpreadsheet();
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(
                    new Blob([data])
                );
                const timestamp = this.generateTimestamp();
                link.setAttribute('download', `${this.selectedFormClass}_${this.reportSelected}_${timestamp}.xlsx`);
                document.body.appendChild(link);
                link.click();
            } catch (error) {
                if(error.response) console.log(error.response)
                else console.log(error)
            }

            this.reportViewerOverlay = false;
        },

         generateTimestamp() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}${month}${day}_${hours}${minutes}${seconds}`;
        },
    },
   
    
}
</script>